export enum AnalyticEventClient {
    TK_PT_SIGNER_ENVELOPE_NEW_UPLOAD = 'Signer/Envelope/Novo/Upload',
    TK_PT_SIGNER_ENVELOPE_NEW_CONFIG = 'Signer/Envelope/Novo/Configuracao',
    TK_PT_SIGNER_ENVELOPE_NEW_SIGNATORY = 'Signer/Envelope/Novo/Signatario',
    TK_PT_SIGNER_ENVELOPE_SIGNATORY_NEW = 'Signer/Envelope/Novo/Signatario/Novo',
    TK_PT_SIGNER_ENVELOPE_SIGNATORY_SEQUENCE = 'Signer/Envelope/Novo/Signatario/Sequencia',
    TK_PT_SIGNER_ENVELOPE_NEW_RESUME = 'Signer/Envelope/Novo/Resumo',
    TK_PT_SIGNER_ENVELOPE_PENDING = 'Signer/Envelope/Pendente',
    TK_PT_SIGNER_ENVELOPE_CONCLUDED = 'Signer/Envelope/Concluido',
    TK_PT_SIGNER_ENVELOPE_EXPIRED = 'Signer/Envelope/Expirado',
    TK_PT_SIGNER_ENVELOPE_DETAIL = 'Signer/Envelope/Detalhe',
    TK_PT_SIGNER_CONFIG_INTEGRATION = 'Signer/Configuracoes/Integracao',
    TK_PT_SIGNER_CONFIG_SEGMENT = 'Signer/Configuracoes/Segmento',
    TK_PT_SIGNER_CONFIG_SEGMENT_NEW = 'Signer/Configuracoes/Segmento/Novo',
    TK_PT_SIGNER_SIGN_TOKEN = 'Signer/Assinatura/Token',
    TK_PT_SIGNER_SIGN = 'Signer/Assinatura',
    TK_PT_SIGNER_SIGN_ELETRONIC = 'Signer/Assinatura/Eletronica',
    TK_PT_SIGNER_SIGN_DIGITAL = 'Signer/Assinatura/Digital',
    TK_PT_SIGNER_SIGN_AUTHORIZATION = 'Signer/Assinatura/Autorizacao',
    TK_PT_SIGNER_SIGN_REPROVE = 'Signer/Assinatura/Autorizacao/Reprovacao',

    TK_PT_SIGNER_ACCESS = 'Signer/Acesso',
    TK_PT_SIGNER_DASHBOARD = 'Signer/Dashboard',
    TK_PT_SIGNER_SIGNATURE_VIEWER = 'Signer/ViewerAssinatura',
    TK_PT_SIGNER_PORTAL_VERIFICATION = 'Signer/PortalVerificacao',
    TK_PT_SIGNER_NEW_ENVELOPE = 'Signer/NovoEnvelope',
    TK_PT_SIGNER_FLOATING = 'Signer/Flutuante',
    TK_PT_SIGNER_SENT = 'Signer/Enviados',
    TK_PT_SIGNER_RECEIVED = 'Signer/Recebidos',
    TK_PT_SIGNER_GENERAL = 'Signer/Geral'
}
